import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';

import { makeUrl } from 'core/utils/utils';

import { catalogCategoriesSelector, catalogProductsSelector } from 'state/catalog/selectors';

import { ErrorBoundary } from 'components/ErrorBoundary';
import { LayoutFullHeightContainer } from 'components/Layout/LayoutFullHeightContainer';

import { RoutePath } from 'RoutePath';

import { DraggableProductList } from 'components/DraggableProductList/DraggableProductList';

const useStyles = makeStyles(theme => ({
    pageWrapper: {
        paddingBottom: 20,
        height: '100%',
        [theme.breakpoints.down('sm')]: {
            paddingBottom: 0,
        },
    },
    productCard: {
        display: 'flex',
        marginBottom: theme.spacing(3),
    },
    container: {
        maxWidth: 720,
        height: '100%',
        [theme.breakpoints.up(1280)]: {
            minWidth: 720,
            margin: '0 auto',
        },
        [theme.breakpoints.up(1920)]: {
            width: 1340,
            margin: '0 auto',
        },
    },
    productCardDetails: {
        flex: 1,
        marginLeft: theme.spacing(2),
    },
    description: {
        display: 'block',
        marginTop: theme.spacing(0.5),
        marginBottom: theme.spacing(1),
        maxHeight: theme.spacing(6.5),
        overflow: 'hidden',
    },
    dot: {
        display: 'inline-block',
        textAlign: 'center',
        width: theme.spacing(3),
    },
    footer: {
        flexGrow: 0,
        flexBasis: 'auto',
        marginTop: theme.spacing(2),
        padding: 0,
        paddingBottom: theme.spacing(7),
        borderTop: '1px solid rgba(15, 24, 37, 0.05)',
    },
    addProductButtonWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        position: 'fixed',
        right: 40,
        bottom: 68,
    },
    addProductMobileButton: {
        padding: '12px 0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderBottom: '1px solid rgba(15, 24, 37, 0.05)',
    },
    addProductMobileButtonIcon: {
        marginRight: 8,
    },
    footerControls: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: theme.spacing(4),
        paddingTop: theme.spacing(3),
        paddingRight: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        width: '100%',
    },
    footerControlsButton: {
        width: '100%',
        height: 48,
    },
    addProductButton: {
        padding: '12px 16px',
        height: 48,
    },
}));

export const CatalogList = () => {
    const classes = useStyles();
    const history = useHistory();
    const isStoreRegistration = window.location.pathname === RoutePath.REGISTRATION_CATALOG;
    const categories = useSelector(catalogCategoriesSelector);
    const products = useSelector(catalogProductsSelector);
    return (
        <ErrorBoundary>
            <div className={classes.pageWrapper}>
                <LayoutFullHeightContainer>
                    <div className={classes.container}>
                        <DraggableProductList
                            categories={categories}
                            products={products}
                            pinToTopCategories={true}
                            onProductClick={(productId, categoryId) => {
                                const path = makeUrl(
                                    isStoreRegistration
                                        ? RoutePath.REGISTRATION_CATALOG_EDIT
                                        : RoutePath.VENDOR_CATALOG_EDIT,
                                    { categoryId, productId },
                                );
                                history.push(path);
                            }}
                        />
                    </div>
                </LayoutFullHeightContainer>
            </div>
        </ErrorBoundary>
    );
};
